// data-testid constants
export const TID = {
  nav: {
    home: "nav-home",
    howItWorks: "nav-how-it-works",
    dataOptions: "nav-data-options",
    faq: "nav-faq",
    contact: "nav-contact",
    login: "nav-login",
    check: "nav-check-my-audience",
    dashboard: "nav-dashboard",
    newRequest: "nav-new-request",
    requests: "nav-requests",
    orders: "nav-orders",
    support: "nav-support",
    account: "nav-account",
    adminDashboard: "nav-admin-dashboard",
    adminRequests: "nav-admin-requests",
    adminOrders: "nav-admin-orders",
    adminUsers: "nav-admin-users",
    adminSettings: "nav-admin-settings",
    logout: "nav-logout",
  },
  home: {
    hero: "home-hero",
    queryBox: "home-query-box",
    checkBtn: "home-check-btn",
    exampleChip: "home-example-chip",
    faqItem: "home-faq-item",
    cta: "home-cta",
  },
  auth: {
    googleBtn: "login-google-btn",
    callback: "auth-callback",
  },
  request: {
    stepPrev: "request-step-prev",
    stepNext: "request-step-next",
    submit: "request-submit-btn",
    saveDraft: "request-save-draft-btn",
    title: "request-title-input",
    plainEnglish: "request-plain-english",
    intendedUse: "request-intended-use",
    quantity: "request-quantity",
    countries: "request-countries",
    industries: "request-industries",
    empMin: "request-emp-min",
    empMax: "request-emp-max",
    seniorities: "request-seniorities",
    titles: "request-titles",
    departments: "request-departments",
    package: "request-package",
    format: "request-format",
    confirm: "request-confirm",
    terms: "request-terms",
  },
  dashboard: {
    kpiActive: "dash-kpi-active",
    kpiQuotes: "dash-kpi-quotes",
    kpiOrders: "dash-kpi-orders",
    kpiCompleted: "dash-kpi-completed",
    newBtn: "dash-new-request-btn",
    reqCard: "dash-request-card",
    orderCard: "dash-order-card",
  },
  detail: {
    approveBtn: "detail-approve-quote",
    declineBtn: "detail-decline-quote",
    reviseBtn: "detail-request-revision",
    payBtn: "detail-mock-pay",
    replyInput: "detail-reply-input",
    replySend: "detail-reply-send",
    downloadSample: "detail-download-sample",
    downloadFile: "detail-download-file",
  },
  admin: {
    createQuote: "admin-create-quote-btn",
    quoteInterp: "admin-quote-interpretation",
    quoteEstVol: "admin-quote-est-vol",
    quoteStdPrice: "admin-quote-std-price",
    quoteVerPrice: "admin-quote-ver-price",
    quoteSubmit: "admin-quote-submit",
    uploadSample: "admin-upload-sample",
    uploadDelivery: "admin-upload-delivery",
    qualityApprove: "admin-quality-approve",
    qualityReject: "admin-quality-reject",
    userRoleSelect: "admin-user-role-select",
    userActivateToggle: "admin-user-activate",
  },
  support: {
    newBtn: "support-new-ticket-btn",
    subject: "support-subject",
    category: "support-category",
    body: "support-body",
    submit: "support-submit",
  },
  contact: {
    name: "contact-name",
    email: "contact-email",
    category: "contact-category",
    message: "contact-message",
    consent: "contact-consent",
    submit: "contact-submit",
  },
};
